import React from 'react';

/** variant: 'default' | 'primary' | 'danger'. Use block for full width. */
export default function GlassButton({ variant = 'default', block = false, className = '', children, ...rest }) {
  const cls = ['glass-btn', variant !== 'default' && `glass-btn--${variant}`, block && 'glass-btn--block', className]
    .filter(Boolean).join(' ');
  return <button type="button" className={cls} {...rest}>{children}</button>;
}